export const SIGNUP_SUCCESSFUL = "SIGNUP_SUCCESSFUL"
export const SIGNIN_SUCCESSFUL = "SIGNIN_SUCCESSFUL"
export const SIGNUP_FAILURE = "SIGNUP_FAILURE"
export const ADD_PROPERTY = "ADD_PROPERTY"
export const REMOVE_PROPERTY = "REMOVE_PROPERTY"
export const ALLOTTEE_PAYMENT_DETAILS = "ALLOTTEE_PAYMENT_DETAILS"
export const ALLOTTEE_SIGNOUT = "ALLOTTEE_SIGNOUT"
export const UPDATE_ALLOTTEE = "UPDATE_ALLOTTEE" 